class ListIngredients extends HTMLElement {
    connectedCallback() {
        this.url = window.location.origin + window.location.pathname;
        this.sectionId = this.dataset.sectionId;
        this.init();
        this._boundOnClick = this.onClick.bind(this);
        this.addEventListener('click', this._boundOnClick);
        this.btns = this.querySelectorAll('.btn-filter');
    }

    disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
    }
    init() {
        this.items = this.querySelectorAll('.item');
        this.popup = this.querySelector('.list-ingredients-popup');
        this.overlay = this.popup.querySelector('.overlay')
        this.slider = this.querySelector('.list-ingredients-popup custom-slider');
        
    }
    changeActiveBtns(val) {
        this.btns.forEach(btn => btn.classList.remove('active'));

        const btn = this.querySelector(`[data-filter="${val}"]`);

        if (btn) btn.classList.add('active');
    }
    onClick(e) {
        const filterBtn = e.target.closest('.btn-filter');
        if (filterBtn) {
            return this.eventHandler({ target: filterBtn });
        }

        const item = e.target.closest('.item');
        if (item) {
            const items = this.querySelectorAll('.item');
            const index = Array.prototype.indexOf.call(items, item);
            return this.open(null, index);
        }

        if (e.target.closest('.btn-close, .overlay')) {
            return this.close();
        }
    }
    async eventHandler(e) {
        const val = e.target.dataset.filter;
        const url = `${window.location.pathname}?sections=${this.sectionId}`;

        this.changeActiveBtns(val);
        
        try {
            const response = await fetch(url);
            const data = await response.json();
            console.log('Response data:', data);
            
            const html = this.getSectionHtml(data[this.sectionId]);
            this.rerenderClientItem(val,'.list', html);
            this.rerenderClientItem(val, '.swiper-wrapper', html);

            this.changeUrl(val);
            this.init();
            
            this.slider.update();

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }
    rerenderClientItem(val, element, html) {
        const wrap = html.querySelector(element);
        const items = wrap.querySelectorAll('[data-item]');
        if(val) {
                const filter_items = Array.from(items).filter( item => item.dataset.item == val)
                this.querySelector(element).innerHTML = '';
                filter_items.forEach(item => this.querySelector(element).appendChild(item));
        }else {
            this.querySelector(element).innerHTML = wrap.innerHTML;
        }
    }
    getSectionHtml(html) {
       return new DOMParser().parseFromString(html, 'text/html');
    }
    changeUrl(blend) {
        window.history.replaceState({}, '', `${this.url}${blend ? `?blend=${blend}` : ''}`);
    }
    open(e, index) {
        this.slider.changeSlide(index);
        this.popup.classList.add('active');
        
        // Calculate scrollbar width dynamically
        const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
        document.body.style.paddingRight = `${scrollbarWidth}px`;
        document.body.classList.add('ingredients-popup-open');
    }
    close() {
        this.popup.classList.remove('active');
        document.body.style.paddingRight = '';
        document.body.classList.remove('ingredients-popup-open');
    }
}

customElements.define('list-ingredients',ListIngredients);